import {
	campaignWhitelistKey,
	privateCampaignWhitelistKey,
} from 'root/src/shared/constants/keys'

export const campaignWhitelistTypes = [
	campaignWhitelistKey,
	privateCampaignWhitelistKey,
]
